<template>
    <div class="page">
        <div class="detail">
            <div class="detail-li" v-for="(item,index) in list" :key="index" v-if="item.answer.length>0">
                <div class="question-name">
                    {{item.question.question}}
                </div>
                <div class="question-type">
                    {{item.question.question_type_cn}}
                </div>
                <div class="question-content">

                    <!--单选题-->
                    <van-radio-group v-model="item.answer[0]" icon-size="16" checked-color="#999" v-if="item.question.question_type == 1">

                        <van-radio class="pd" :name="itemGroup.question_options_id" label-disabled v-for="(itemGroup,indexGroup) in item.question_options" :key="indexGroup">
                            {{itemGroup.idx}}、{{itemGroup.options}}
                        </van-radio>

                    </van-radio-group>

                    <!--多选题-->
                    <van-checkbox-group v-model="item.answer" icon-size="16" checked-color="#999" v-if="item.question.question_type == 2">

                        <van-checkbox class="pd" shape="square" :name="itemGroup.question_options_id" label-disabled v-for="(itemGroup,indexGroup) in item.question_options" :key="indexGroup">
                            {{itemGroup.idx}}、{{itemGroup.options}}
                        </van-checkbox>

                    </van-checkbox-group>

                    <!--判断题-->
                    <van-radio-group v-model="item.answer[0]" icon-size="16" checked-color="#999" v-if="item.question.question_type == 3">
                        <van-radio class="pd" name="1" label-disabled>正确</van-radio>
                        <van-radio class="pd" name="0" label-disabled>错误</van-radio>
                    </van-radio-group>
                </div>
                <van-divider />
                <div class="question-result">
                    <span class="yes" v-if="item.result_answer">回答正确</span>
                    <span class="no" v-if="!item.result_answer">回答错误</span>
                </div>
                <div class="question-result lh18">
                    <div class="question-answer">正确答案</div>
                    <div class="question-answer-col">
                        {{item.correct_answer}}
                    </div>
                </div>
                <div class="question-result lh18">
                    <div class="question-answer">解析</div>
                    <div class="question-answer-col">
                        {{item.question.remark || '暂无解析'}}
                    </div>
                </div>
                <div class="qeustion-time">
                    {{item.answer_date}}
                </div>
            </div>
            <van-empty description="暂无随测详情记录" v-if="!is_answer"/>
        </div>
    </div>
</template>

<script>
    import {List,RadioGroup, Radio,Divider,Checkbox, CheckboxGroup,Empty} from 'vant';
    export default {
        name: "detail",
        components:{
            [List.name]:List,
            [Radio.name]:Radio,
            [RadioGroup.name]:RadioGroup,
            [Divider.name]:Divider,
            [Checkbox.name]:Checkbox,
            [CheckboxGroup.name]:CheckboxGroup,
            [Empty.name]:Empty
        },
        data(){
            return {
                question_stat_user_id:'',
                list:[],
                is_answer:true
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.question_stat_user_id=this.util.getQueryStr('question_stat_user_id') || '';
            this.getQuestionTestDetail();
        },
        methods:{
            getQuestionTestDetail(){
                var _self=this;
                this.util.server.mini_question.question_test_detail({
                    data:{
                        question_stat_user_id:this.question_stat_user_id
                    },
                    callback:function (res) {
                        if(res.data.length>0){
                            var data = res.data;
                            var is_answer = [];

                            for (var i=0;i<data.length;i++){
                                var item = data[i];
                                if(item.answer.length == 0){
                                   is_answer.push(false);
                                }else{
                                   is_answer.push(true);
                                }

                                var correct_answer = '';
                                var result_answer = false;
                                for (var j=0;j<item.question_options.length;j++){
                                    var option = item.question_options[j];

                                    if(option.is_true == 1  && item.question.question_type != 3){
                                        correct_answer += option.idx + '、';

                                        var answer = item.answer;
                                        if(!item.answer){
                                            answer = item.answer.join(',');
                                        }

                                        if(answer.indexOf(option.question_options_id) > -1){
                                            result_answer = true;
                                        }else{
                                            result_answer = false;
                                        }
                                    }

                                    if(option.is_true == 1 && item.question.question_type == 3){
                                        correct_answer = option.options + '、';
                                        if(option.is_change==1 && option.is_true == 1){
                                            result_answer = true;
                                        }
                                    }
                                }

                                if(correct_answer.length > 0){
                                    correct_answer = correct_answer.substring(0,correct_answer.length-1);
                                }

                                data[i].correct_answer = correct_answer;
                                data[i].result_answer = result_answer;
                            }

                            if(is_answer.join(',').indexOf('true') == -1){
                                _self.is_answer = false
                            }


                            _self.list=data;

                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .page{
        width: 100%;
        height: 100%;
    }
    .detail-li{
        margin: 10px;
        box-shadow: 1px 0 10px #eee;
        background-color: #fff;
        border: 1px solid #eee;
        padding: 15px 10px;
        border-radius: 10px;
    }
    .question-content .pd{
        margin: 10px;
    }
    .question-content .pd >>> .van-radio__label{
        color: #999;
    }
    .question-type{
        font-size: 12px;
        color: #999;
        margin: 10px;
    }
    .question-result{
        font-weight: bold;
        margin: 10px 0;
    }
    .question-result .yes{
        color: #44b549;
    }
    .question-result .no{
        color: #c9302c;
    }
    .question-answer,.question-answer-col{
        font-size: 12px;
    }
    .question-answer-col{
        color: #555;
        font-weight: 500;
    }
    .lh18{
        line-height: 18px;
    }
    .qeustion-time{
        text-align: right;
        color: #999;
        font-size: 12px;
    }
</style>
